import { combineReducers } from "@reduxjs/toolkit";
import common from "./commonSlice";
import notification from "../notificationSlice";

const reducer = combineReducers({
  common,
  notification,
});

export default reducer;
